<template>
  <div class="question-container">
    <!-- VIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>

          <div class="question" v-if="activityType == 'activity'">
            <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="question.formattedTitle"></div>
            <div class="question-text" v-else v-html="question.formattedTitle"></div>
          </div>

          <div class="question" v-else>
            <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></div>
            <div class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></div>
          </div>
        </div>
        <div class="col-md-7">
          <div v-if="answer && answer.answerText">
            <div class="row">
              <div class="col-md-4 p-0">
                <div v-for="(item, index) of stringToJsonConvert(answer[JsonFieldToDisplay()], 'Overview')" :key="index">
                  <div class="image-edit-mode d-flex">
                    <img @contextmenu.prevent class="image-edit-mode__image__overview mt-4" :src="!!item.thumbnailURL ? item.thumbnailURL : item.imageURL" alt="image response" />
                  </div>
                </div>
              </div>
              <div class="col-md-8 p-0">
                <div class="skin-left-margin">
                  <div class="row">
                    <span class="text-redness-dryness"
                      >Redness average:
                      <span class="average-redness-score">
                        {{ overallRednessScore }}
                      </span>
                    </span>
                  </div>
                  <div class="row">
                    <div v-for="(item, index) of stringToJsonConvert(answer[JsonFieldToDisplay()], 'Redness')" :key="index">
                      <div class="image-edit-mode d-flex flex-wrap">
                        <img @contextmenu.prevent class="Image-Orange-Light-Image-1" :src="!!item.thumbnailURL ? item.thumbnailURL : item.imageURL" alt="image response" />
                      </div>
                      <div class="row">
                        <div class="progress progress-redness mt-6">
                          <div
                            class="
                              progress-bar
                              progress-bar-redness
                              progress-bar-success
                            "
                            role="progressbar"
                            :aria-valuenow="item.roundedImageScore"
                            aria-valuemin="0"
                            aria-valuemax="5"
                            :style="{
                              width: calculateBarWidth(item.roundedImageScore, 5) + '%'
                            }"
                          >
                            <span class="sr-only">{{ roundOffToThreeDigits(item.roundedImageScore) }}% Complete</span>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <span class="rank-redness">
                          {{ roundOffToThreeDigits(item.roundedImageScore) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="dryness-left-margin mt-8">
                    <div class="row">
                      <span class="text-redness-dryness"
                        >Dryness average:
                        <span class="average-dryness-score">
                          {{ overallDrynessScore }}
                        </span>
                      </span>
                    </div>
                    <div class="row">
                      <div v-for="(item, index) of stringToJsonConvert(answer[JsonFieldToDisplay()], 'Dryness')" :key="index">
                        <div class="image-edit-mode d-flex flex-wrap">
                          <img @contextmenu.prevent class="Image-Orange-Light-Image-1" :src="!!item.thumbnailURL ? item.thumbnailURL : item.imageURL" alt="image response" />
                        </div>
                        <div class="row">
                          <div class="progress progress-dryness mt-6">
                            <div
                              class="
                                progress-bar
                                progress-bar-dryness
                                progress-bar-success
                              "
                              role="progressbar"
                              :aria-valuenow="item.roundedImageScore"
                              aria-valuemin="0"
                              aria-valuemax="5"
                              :style="{
                                width: calculateBarWidth(item.roundedImageScore, 5) + '%'
                              }"
                            >
                              <span class="sr-only">{{ roundOffToThreeDigits(item.roundedImageScore) }}% Complete</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <span class="rank-dryness">
                            {{ roundOffToThreeDigits(item.roundedImageScore) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>

          <div class="question" v-if="activityType == 'activity'">
            <div class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="question.formattedTitle"></div>
            <div class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="question.formattedTitle"></div>
          </div>

          <div class="question" v-else>
            <div class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></div>
            <div class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></div>
          </div>
        </div>
        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <div v-if="answer && answer.displayAnswerText">
            <div class="row">
              <div class="col-md-4 p-0">
                <div v-for="(item, index) of stringToJsonConvert(answer[JsonFieldToDisplay()], 'Overview')" :key="index">
                  <div class="image-edit-mode d-flex">
                    <img @contextmenu.prevent class="image-edit-mode__image__overview mt-4" :src="!!item.thumbnailURL ? item.thumbnailURL : item.imageURL" alt="image response" />
                  </div>
                </div>
              </div>
              <div class="col-md-8 p-0">
                <div class="skin-left-margin">
                  <div class="row">
                    <span class="text-redness-dryness"
                      >Redness average:
                      <span class="average-redness-score">
                        {{ overallRednessScore }}
                      </span>
                    </span>
                  </div>
                  <div class="row">
                    <div v-for="(item, index) of stringToJsonConvert(answer[JsonFieldToDisplay()], 'Redness')" :key="index">
                      <div class="image-edit-mode d-flex flex-wrap">
                        <img @contextmenu.prevent class="Image-Orange-Light-Image-1" :src="!!item.thumbnailURL ? item.thumbnailURL : item.imageURL" alt="image response" />
                      </div>
                      <div class="row">
                        <div class="progress progress-redness mt-6">
                          <div
                            class="
                              progress-bar
                              progress-bar-redness
                              progress-bar-success
                            "
                            role="progressbar"
                            :aria-valuenow="item.roundedImageScore"
                            aria-valuemin="0"
                            aria-valuemax="5"
                            :style="{
                              width: calculateBarWidth(item.roundedImageScore, 5) + '%'
                            }"
                          >
                            <span class="sr-only">{{ roundOffToThreeDigits(item.roundedImageScore) }}% Complete</span>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <span class="rank-redness">
                          {{ roundOffToThreeDigits(item.roundedImageScore) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="dryness-left-margin mt-8">
                    <div class="row">
                      <span class="text-redness-dryness"
                        >Dryness average:
                        <span class="average-dryness-score">
                          {{ overallDrynessScore }}
                        </span>
                      </span>
                    </div>
                    <div class="row">
                      <div v-for="(item, index) of stringToJsonConvert(answer[JsonFieldToDisplay()], 'Dryness')" :key="index">
                        <div class="image-edit-mode d-flex flex-wrap">
                          <img @contextmenu.prevent class="Image-Orange-Light-Image-1" :src="!!item.thumbnailURL ? item.thumbnailURL : item.imageURL" alt="image response" />
                        </div>
                        <div class="row">
                          <div class="progress progress-dryness mt-6">
                            <div
                              class="
                                progress-bar
                                progress-bar-dryness
                                progress-bar-success
                              "
                              role="progressbar"
                              :aria-valuenow="item.roundedImageScore"
                              aria-valuemin="0"
                              aria-valuemax="5"
                              :style="{
                                width: calculateBarWidth(item.roundedImageScore, 5) + '%'
                              }"
                            >
                              <span class="sr-only">{{ roundOffToThreeDigits(item.roundedImageScore) }}% Complete</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <span class="rank-dryness">
                            {{ roundOffToThreeDigits(item.roundedImageScore) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PREVIEW MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 fw-bold">
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>

              <div class="question" v-if="activityType == 'activity'">
                <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="question.formattedTitle"></div>
                <div class="question-text" v-else v-html="question.formattedTitle"></div>
              </div>

              <div class="question" v-else>
                <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></div>
                <div class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></div>
              </div>
            </div>
            <!-- CURRENT ANSWER -->
            <div class="col-md-12">
              <div v-if="answer && answer.answer_text">
                <div class="row mt-10">
                  <div class="col-md-4 p-0">
                    <div v-for="(item, index) of stringToJsonConvert(historyResponseData, 'Overview')" :key="index">
                      <div class="image-edit-mode d-flex">
                        <img @contextmenu.prevent class="image-edit-mode__image__overview mt-4" :src="!!item.thumbnailURL ? item.thumbnailURL : item.imageURL" alt="image response" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-8 p-0">
                    <div class="skin-left-margin">
                      <div class="row">
                        <span class="text-redness-dryness"
                          >Redness average:
                          <span class="average-redness-score">
                            {{ overallRednessScore }}
                          </span>
                        </span>
                      </div>
                      <div class="row">
                        <div v-for="(item, index) of stringToJsonConvert(historyResponseData, 'Redness')" :key="index">
                          <div class="image-edit-mode d-flex flex-wrap">
                            <img @contextmenu.prevent class="Image-Orange-Light-Image-1" :src="!!item.thumbnailURL ? item.thumbnailURL : item.imageURL" alt="image response" />
                          </div>
                          <div class="row">
                            <div class="progress progress-redness mt-6">
                              <div
                                class="
                              progress-bar
                              progress-bar-redness
                              progress-bar-success
                            "
                                role="progressbar"
                                :aria-valuenow="item.roundedImageScore"
                                aria-valuemin="0"
                                aria-valuemax="5"
                                :style="{
                                  width: calculateBarWidth(item.roundedImageScore, 5) + '%'
                                }"
                              >
                                <span class="sr-only">{{ roundOffToThreeDigits(item.roundedImageScore) }}% Complete</span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <span class="rank-redness">
                              {{ roundOffToThreeDigits(item.roundedImageScore) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="dryness-left-margin mt-8">
                        <div class="row">
                          <span class="text-redness-dryness"
                            >Dryness average:
                            <span class="average-dryness-score">
                              {{ overallDrynessScore }}
                            </span>
                          </span>
                        </div>
                        <div class="row">
                          <div v-for="(item, index) of stringToJsonConvert(historyResponseData, 'Dryness')" :key="index">
                            <div class="image-edit-mode d-flex flex-wrap">
                              <img @contextmenu.prevent class="Image-Orange-Light-Image-1" :src="!!item.thumbnailURL ? item.thumbnailURL : item.imageURL" alt="image response" />
                            </div>
                            <div class="row">
                              <div class="progress progress-dryness mt-6">
                                <div
                                  class="
                                progress-bar
                                progress-bar-dryness
                                progress-bar-success
                              "
                                  role="progressbar"
                                  :aria-valuenow="item.roundedImageScore"
                                  aria-valuemin="0"
                                  aria-valuemax="5"
                                  :style="{
                                    width: calculateBarWidth(item.roundedImageScore, 5) + '%'
                                  }"
                                >
                                  <span class="sr-only">{{ roundOffToThreeDigits(item.roundedImageScore) }}% Complete</span>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <span class="rank-dryness">
                                {{ roundOffToThreeDigits(item.roundedImageScore) }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7"></div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
export default {
  name: "SkinAnalyzerResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      overallRednessScore: "",
      overallDrynessScore: "",
      historyResponseData: ""
    };
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    selectedLanguageCulture: String,
    stepIndex: Number,
    surveyData: Object,
    usage: Object,
    activityType: String
  },
  methods: {
    stringToJsonConvert(stringData, type) {
      let list = [];
      let sum = 0;
      if (stringData) {
        list = JSON.parse(stringData);
      }
      let filterList = [];
      if (type == "Overview") {
        filterList = list.filter(item => item.imageType == "overview");
      }
      if (type == "Redness") {
        filterList = list.filter(item => item.imageType == "redness");
        filterList.map(e => {
          sum = Number(sum) + Number(e.imageScore);
        });
        const step = 0.5;
        this.overallRednessScore = (Math.round(sum / 3 / step) * step).toFixed(1);
      }
      if (type == "Dryness") {
        filterList = list.filter(item => item.imageType == "dryness");
        filterList.map(e => {
          sum = Number(sum) + Number(e.imageScore);
        });
        const step = 0.5;
        this.overallDrynessScore = (Math.round(sum / 3 / step) * step).toFixed(1);
      }
      return filterList;
    },
    calculateBarWidth(currentValue, maxValue) {
      const width = (currentValue * 100) / maxValue;
      return width;
    },
    roundOffToThreeDigits(value) {
      const val = parseFloat(value).toFixed(1);
      return val > 0 ? val : 0.0;
    },
    roundOffToOneDigit(value) {
      const val = parseFloat(value).toFixed(1);
      return val > 0 ? val : 0.0;
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  },
  mounted() {
    this.historyResponseData = this.answer.display_answer_text;
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.Image-Orange-Light-Image-1 {
  width: 60px;
  height: 60px;
  flex-grow: 0;
  margin: 6px 4.8px 0 0;
}
.image-edit-mode__image__overview {
  width: 100%;
  height: 98px;
}
.progress-bar-dryness {
  border: solid 1px #007bff !important;
  background-color: #007bff;
  border-radius: 15px !important;
}
.progress-bar-redness {
  background-color: #f16559;
  border: solid 1px #f16559 !important;
  border-radius: 15px !important;
}
.progress-dryness {
  border: solid 1px #007bff !important;
}
.progress-redness {
  border: solid 1px #f16559 !important;
}
.progress {
  width: 60px !important;
  height: 8px;
  margin-bottom: 0px;
  border-radius: 15px;
  background-color: white;
}
span.rank-redness {
  width: 60px;
  font-family: "RobotoRegular";
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0px;
  text-align: center;
  color: #f16559;
}
span.rank-dryness {
  width: 60px;
  font-family: "RobotoRegular";
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0px;
  text-align: center;
  color: #007bff;
}
.text-redness-dryness {
  font-family: "RobotoRegular";
  font-size: 12px;
  text-align: center;
  font-weight: 600;
  color: #4a4a4a;
}
.average-redness-score {
  font-family: "RobotoRegular";
  font-size: 12px;
  color: #f16559;
}
.average-dryness-score {
  font-family: "RobotoRegular";
  font-size: 12px;
  color: #007bff;
}
.skin-left-margin {
  margin-left: 14px !important;
}
.dryness-left-margin {
  margin-left: 14px !important;
}
</style>
